module.exports = __webpack_public_path__ + "static/media/skin-2.4e90b845.svg";